

<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-header>
      </mat-card-header>    
    <mat-card-content>

    @if(hasAccessHolder == false){
        <h4>Add Parker to Amano One</h4>
        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:5px;;" (click)="onAddParkerToAmanoOne()" >Add Amano One Profile</button> 
    }
    @else{
    
    @if(this._parkerDetail.cardNumber == null || this._parkerDetail.cardNumber == ''){
        <span style="margin-left: 0px;margin-top:20px;margin-bottom:20px;"  class="lanai-page-title">Card Number: --</span>
        
    }
    @else{
        <span style="margin-left: 0px;margin-top:20px;margin-bottom:20px;"  class="lanai-page-title">Card Number: {{ this._parkerDetail.cardNumber }}</span>
    }
    <!-- <mat-icon aria-hidden="false" 
            class="mimic-button-hover"
            style="margin-top:25px;margin-left:15px;"
            aria-label="Reload Setting Data" 
            fontIcon="refresh"  
            matTooltip="Reload Access Groups, Status and Mode Settings"
            (click)="initSettingsData()"></mat-icon> -->
    <div style="height:350px;overflow-y: auto;overflow-x: hidden;">
    <div class="row" style="margin-top:40px;margin-left:5px;">
        <div class="col-8">
            @if(accessGroupUpdateInProgress){
                <div style="margin-left:20px;margin-top:20px;height:150px;">
                    <span style="font-size:18px;font-weight:bold;">Updating Access Groups...</span><br />
                    <mat-progress-bar mode="indeterminate" style="margin-top:20px;width:400px;height:40px;"></mat-progress-bar>
                </div>
            }
            @else {
                <div class="row">
                    <div class="col-5" style="border:1px solid #4c4a4a;padding:10px;height:270px;">
                        <strong>Available PARC Access Groups</strong>
                        <div style="margin-left:45px;">
                            <mat-selection-list  
                                [multiple]="false" 
                                hideSingleSelectionIndicator 
                                style="height:200px;overflow-y:auto;width:90%;overflow-x: hidden;"
                                (selectionChange)="onAccessGroupChange($event)"
                                [(ngModel)]="selectedSourceAccessGroup">
                                @for (group of amanoOneAccessGroups; track group) {
                                <mat-list-option [value]="group.accessGroupId">{{group.name}}</mat-list-option>
                                }
                            </mat-selection-list>
                        </div>
                    </div>
                    <div class="col-2 d-flex justify-content-center align-items-center">
                        <div style="margin-top:20px;">
                        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:5px;;" [disabled]="disableAddAccessGroup" (click)="onAddNewAccessGroup()">>></button> <br />
                        <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:5px;" [disabled]="disableRemoveAccessGroup" (click)="onRemoveAccessGroup()"><<</button> 
                        </div>
                    </div>
                    <div class="col-5" style="border:1px solid #4c4a4a;padding:10px;height:270px;">
                        <strong>Selected PARC Access Groups</strong>
                        <mat-selection-list  
                            [multiple]="false" 
                            hideSingleSelectionIndicator 
                            style="height:200px;overflow-y:auto;width:90%;overflow-x: hidden;"
                            (selectionChange)="onCurrentMemberAccessGroupChange($event)"
                            [(ngModel)]="selectedDestinationAccessGrouop"
                            >
                            @for (group of amanoOneAccessGroupsMemberOf; track group) {
                            <mat-list-option [value]="group.accessGroupId">{{group.name}}</mat-list-option>
                            }
                        </mat-selection-list>
                    </div>
                </div> 
            }
        </div>
        <div class="col-4"> 
        <div class="row">
        <div class="col-6">
            @if(modeUpdateInProgress)
            {
                <div style="margin-top:10px;margin-left:80px;">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
            }
            @else
            {
             <mat-form-field appearance="fill" style="width:98%;color:gray;margin-left:10px;">
               <mat-label>Select Mode*</mat-label>
                    <mat-select (selectionChange)="onModeChange($event)" [(ngModel)]="modeSettingValue">
                        <mat-option value="">Select Mode</mat-option>
                        <mat-option value="Normal">Normal</mat-option>
                        <mat-option value="Locked">Locked</mat-option>
                        <mat-option value="Override">Override</mat-option>
                        <mat-option value="Override AP">Override AP</mat-option>
                        <mat-option value="Inactive">Inactive</mat-option>
                        <mat-option value="AP Inactive">AP Inactive</mat-option>
                    </mat-select>
                </mat-form-field>
            }
        </div>
        <div class="col-6">
             <mat-form-field appearance="fill" style="width:98%;color:gray">
               <mat-label>Select Status*</mat-label>
                    <mat-select (selectionChange)="onStatusChange($event)" [(ngModel)]="statusSettingValue">
                        <mat-option value="">Select Status</mat-option>
                        <mat-option value="In">In</mat-option>
                        <mat-option value="Out">Out</mat-option>
                        <mat-option value="Neutral">Neutral</mat-option>
                    </mat-select>
                </mat-form-field>
        </div>
        </div>
        <hr />
        <div class="row mt-4">
            @if(this._parkerDetail.cardNumber != null && this._parkerDetail.cardNumber != ''){
                @if(matchingParcsCardNumberExist){
                    <div class="col-6" style="margin-top:0px;">
                        <mat-form-field appearance="fill" style="width:98%;color:gray;margin-left:10px;">
                        <mat-label>Select Credential Type*</mat-label>
                                <mat-select (selectionChange)="onCredentialTypeChange($event)" [(ngModel)]="credentialTypeSettingValue">
                                    <mat-option value="">Select Credential Code</mat-option>
                                 @for (credentialType of this.credentialTypeList; track credentialType) {
                                    <mat-option [value]="credentialType.credentialTypeName">{{credentialType.credentialTypeName}}</mat-option>
                                }
                                </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        @if(credentialTypeSettingValue == 'AVI/Prox/Magstripe')
                        {
                        <mat-form-field appearance="fill" style="width:98%;color:gray;">
                        <mat-label>Select Credential Code*</mat-label>
                                <mat-select (selectionChange)="onCredentialCodeChange($event)" [(ngModel)]="credentialCodeSettingValue" [disabled]="credentialTypeDisabled">
                                <mat-option value="">Select Credential Code</mat-option>
                                     @for (systemCode of this.systemCodeList; track systemCode) {
                                        <mat-option [value]="systemCode.credentialCode">{{systemCode.credentialCode}}</mat-option>
                                    }
                                </mat-select>

                            </mat-form-field>
                        }
                        @else {
                            <span>System Code only applicable for AVI/Prox/Magstripe Credential Type</span>
                        }
                    </div>
                     
                <div class="col-12 text-end" style="width:99%;">
                    <button type="button" class="btn btn-primary mt-3 ace-blue" (click)="onUpdateCredentials()"  [disabled]="isCredentialSaveDisabled">Update Credentials</button>
                </div>
                }
                @else {
                    <span>This Parker's card number does not match any Amano One credentials.</span>
                }
            }
            @else {
                <span>This Parker does not have a card number.</span>
            }
       </div>
    </div>
    </div>
    </div>
}
</mat-card-content>
<mat-card-actions style="margin-top:20px;">
    <hr />

  </mat-card-actions>
</mat-card>




